import { useRef, useState } from "react";

import { EditorContent } from "@/features/notes/components/Editor/components/EditorContent";
import { EditorData } from "../../../types";
import { EditorFooter } from "./EditorFooter";
import { EditorProps } from "..";
import { NoteTags } from "../../Note/NoteTags";
import clsx from "clsx";

export function EditorDesktop({ initialData, isEditable = true, note, refetchedNote, onChange }: EditorProps) {
  const [isLinkEditMode, setIsLinkEditMode] = useState(false);
  const dataRef = useRef<EditorData>(initialData ?? { html_content: null, text_content: null });
  const canEdit = isEditable && !note?.locked;

  const handleChange = (data: EditorData) => {
    dataRef.current = data;
    onChange?.(data);
  };

  return (
    <div className="flex h-full flex-col pb-2">
      <div className="flex-1 overflow-auto px-4">
        <EditorContent
          initialContent={initialData?.html_content}
          isEditable={canEdit}
          isLinkEditMode={isLinkEditMode}
          note={note}
          refetchedNote={refetchedNote}
          onSetIsLinkEditMode={setIsLinkEditMode}
          onChange={(text_content, html_content) => handleChange({ ...dataRef.current, text_content, html_content })}
        />
      </div>
      {note?.tags.length ? <NoteTags className="shrink-0 px-4 pt-2" tags={note.tags} /> : null}
      <div className={clsx("px-4 pt-1", { hidden: !canEdit })}>
        <EditorFooter onSetIsLinkEditMode={setIsLinkEditMode} />
      </div>
    </div>
  );
}
